import api   from '../../../../configs/api'
import Form  from '../../../../display/forms/FormElements'

import Word from '../../../../things/Word'

import getExistingSuggestions from '../../../../things/getExistingSuggestions'

const disabledSuggestions = getExistingSuggestions( { ref:'additionalType' , refClazz:Word , include:true } ) ;

const getElements = ( { additionalType , name , value } = {} ) =>
([
    {
        type : Form.TEXTFIELD ,
        init :
        {
            id           : 'name',
            key          : 'name',
            label        : name.label ,
            autoFocus    : true,
            fullWidth    : true,
            helperText   : 'Obligatoire',
            margin       : 'normal',
            required     : true,
            select       : false,
            autoComplete : 'off' ,
            type         : 'search',
            variant      : 'outlined'
        }
    },
    {
        type : Form.SEARCH_SELECTOR ,
        path : api.thesaurus.organizations_numbers_types ,
        init :
        {
            id         : 'additionalType',
            key        : 'additionalType',
            label      : additionalType.label ,
            autoFocus  : false,
            fullWidth  : true,
            margin     : 'normal',
            required   : true,
            type       : 'search',
            variant    : 'outlined'
        },
        disabledSuggestions,
        selector : { i18n :
        {
            empty       : 'Aucun type disponible.' ,
            title       : 'Sélectionner un type',
            description : 'Veuillez sélectionner un type d\'identifiant ci-dessous.' ,
        }}
    },
    {
        type : Form.TEXTFIELD ,
        init :
        {
            id           : 'value',
            key          : 'value',
            label        : value.label,
            autoFocus    : false,
            fullWidth    : true,
            helperText   : 'Obligatoire',
            margin       : 'normal',
            required     : true,
            select       : false,
            autoComplete : 'off' ,
            type         : 'search',
            variant      : 'outlined'
        }
    }
]);

const elements = getElements(
{
    additionalType :
    {
        label : 'Type de l\'identifiant'
    },
    name :
    {
        label : 'Nom de l\'identifiant' ,
        input : 'Type d\'identifiant...'
    } ,
    value :
    {
        label : 'Valeur'
    }
});

const numbers =
{
    add :
    {
        elements,
        agree       : 'Créer' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez remplir le formulaire ci-dessous pour créer un identifiant.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...' ,
        success     : 'Ajout du nouvel identifiant réussi!' ,
        title       : 'Ajouter un identifiant',
    },
    edit :
    {
        elements,
        agree       : 'Sauver' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez remplir le formulaire ci-dessous pour modifier cet identifiant.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...' ,
        success     : 'Mise à jour réussie!' ,
        title       : 'Modifier l\'identifiant' ,
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer cet identifiant:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer l\'identifiant ?'
    },
    title : 'Indexation' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default numbers ;
